import {
    mapActions,
    mapGetters,
} from 'vuex'

export default {
    computed: {
        ...mapGetters({
            availableDays: 'orders/availableDays',
        }),
    },
    methods: {
        ...mapActions({
            fetchAvailableDays: 'orders/fetchAvailableDays',
        }),
        async setAvailableDays() {
            const time = this.duration.split(':')

            const hour = parseInt(time[0]) * 60
            const min = parseInt(time[1])
            const total = hour + min

            await this.fetchAvailableDays({
                service_id: this.service_id,
                office_id: this.office_id,
                duration: total,
            })
        },
    },
}
